package horcrux.frontend.common.views.auth

import horcrux.frontend.common.GlobalAppState
import horcrux.frontend.common.views.components.containers.DialogView
import mui.material.DialogContentText
import mui.material.DialogTitle
import react.FC
import react.Props

external interface VerifyEmailDialogProps : Props {
    var globalAppState: GlobalAppState
}

val VerifyEmailDialog = FC<VerifyEmailDialogProps> { props ->
    DialogView {
        val title = "Verify your Email Address"
        this.title = title
        this.showDialogState = props.globalAppState.showVerifyEmailDialogState
        DialogTitle { +title }
        DialogContentText { +"Check your email inbox to verify your email address." }
    }
}
